"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var hslRegex = /hsl\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%)\)/;
var calculateHsl = core_1.memo(function (values, ranges, easing) {
    var _a, _b;
    var min = ranges[0], max = ranges[1];
    var minMatch = (_a = hslRegex.exec(min)) === null || _a === void 0 ? void 0 : _a.slice(1);
    var maxMatch = (_b = hslRegex.exec(max)) === null || _b === void 0 ? void 0 : _b.slice(1);
    if (minMatch && minMatch.length === 3 && maxMatch && maxMatch.length === 3) {
        var minHue = minMatch[0], minSat = minMatch[1], minLight = minMatch[2];
        var maxHue = maxMatch[0], maxSat = maxMatch[1], maxLight = maxMatch[2];
        var hue = core_1.interpolate(values.h, [parseFloat(minHue), parseFloat(maxHue)], easing);
        var saturation = core_1.interpolate(values.s, [parseFloat(minSat), parseFloat(maxSat)], easing);
        var lightness = core_1.interpolate(values.l, [parseFloat(minLight), parseFloat(maxLight)], easing);
        return "hsl(" + hue + ", " + saturation + "%, " + lightness + "%)";
    }
    throw new Error("Modular System Error -> \"" + min + "\" or \"" + max + "\" is not a valid hsl color string.");
});
exports.hsl = function (value, range, easing) { return function (props) {
    var theme = props.theme;
    var values = core_1.getHslValue(value, theme);
    var ranges = core_1.getRange(range, theme);
    if (ranges.length === 1) {
        return ranges[0];
    }
    return calculateHsl(values, ranges, easing);
}; };
exports.useHsl = function (value, range, easing) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.hsl(value, range, easing)({ theme: theme });
};
//# sourceMappingURL=hsl.js.map